import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetDataFlowMetricsResData } from "./GetDataFlowMetricsResData";

const ENDPOINT = "/dataflow/services/metrics";

export class GetDataFlowMetricsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    public async execute(): Promise<GetDataFlowMetricsResData> {
        let res = await this.executeCommand();
        return new GetDataFlowMetricsResData(res);
    }
}
